import { useTranslation } from "react-i18next";

// Reset (default -> team, calls the backend, only shown for source==='team')
// and Discard (drops an in-progress draft locally, shown whenever dirty,
// independent of source — S3) are two distinct affordances that must both
// be reachable at once for a dirty customized signal.
export const EditorFooter = ({
  showReset,
  showDiscard,
  leftNote,
  saveState, // idle | saving | saved | error
  isDirty,
  onReset,
  onDiscard,
  onSave,
}) => {
  const { t } = useTranslation();
  const saveDisabled = !isDirty || saveState === "saving";

  return (
    <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-gray-100 pt-3.5">
      <div className="flex flex-wrap items-center gap-3 text-xs">
        {showReset && (
          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-white px-2.5 py-1 text-gray-600 hover:bg-gray-50 hover:text-gray-900"
          >
            <span aria-hidden="true">{"↺"}</span>
            <span>
              {t("pages.settings.signalsPlaybooks.editor.resetToDefault")}
            </span>
          </button>
        )}
        {showDiscard && (
          <button
            type="button"
            onClick={onDiscard}
            className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-white px-2.5 py-1 text-gray-600 hover:bg-gray-50 hover:text-gray-900"
          >
            <span>
              {t("pages.settings.signalsPlaybooks.editor.discardChanges")}
            </span>
          </button>
        )}
        {leftNote && <span className="text-gray-400">{leftNote}</span>}
      </div>

      <div className="flex items-center gap-3">
        {saveState === "error" && (
          <span className="text-xs text-red-600">
            {t("pages.settings.signalsPlaybooks.editor.saveError")}
          </span>
        )}
        {isDirty && saveState === "idle" && (
          <span className="inline-flex items-center gap-1.5 text-xs text-amber-700">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-600" />
            {t("pages.settings.signalsPlaybooks.editor.unsavedChanges")}
          </span>
        )}
        {saveState === "saving" && (
          <span className="inline-flex items-center gap-1.5 text-xs text-gray-500">
            <span className="h-3 w-3 rounded-full border-2 border-gray-200 border-t-gray-500 motion-safe:animate-spin" />
            {t("pages.settings.signalsPlaybooks.editor.saving")}
          </span>
        )}
        {saveState === "saved" && (
          <span className="motion-safe:animation-saved-pop inline-flex items-center gap-1.5 text-xs text-green-600">
            <span className="flex h-[15px] w-[15px] items-center justify-center rounded-full bg-green-600 text-[9px] text-white">
              {"✓"}
            </span>
            {t("pages.settings.signalsPlaybooks.editor.saved")}
          </span>
        )}
        <button
          type="button"
          onClick={onSave}
          disabled={saveDisabled}
          className={`rounded-lg border px-4 py-1.5 text-sm font-medium ${
            saveDisabled
              ? "cursor-default border-gray-200 bg-gray-100 text-gray-400"
              : "cursor-pointer border-blue-600 bg-blue-600 text-white hover:bg-blue-700"
          }`}
        >
          {t("pages.settings.signalsPlaybooks.editor.saveChanges")}
        </button>
      </div>
    </div>
  );
};
